'use strict';

import {siteConfig} from '../siteConfig';

module.exports = function($uibModal, dialog, Department, Member, $state, departments, $translate, myTenant) {
    var _this = this;
    this.siteConfig = siteConfig;
    // console.log('this.siteConfig', this.siteConfig)
    _this.tagSync = {
        idGoogleSheet: localStorage.getItem('idGoogleSheet') || '',
        sheetName: localStorage.getItem('sheetName') || '',
    }

    // TENANT VOOLKS CERTIFICATIONS
    this.myTenant = myTenant;

    console.log('this.myTenant',this.myTenant)
    _this.myTenant.load().then(() => {
        this.tenantId = _this.myTenant.get().id;
    })

    this.department = departments?.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];

    this.dataComplete = () => {
        return (this.tagSync.idGoogleSheet !== '' && this.tagSync.sheetName !== '');
    }

    this.accept = () => {
        localStorage.setItem('idGoogleSheet', _this.tagSync.idGoogleSheet);
        localStorage.setItem('sheetName', _this.tagSync.sheetName);
        $state.go("dashboard.departments.department.tagsyncImport", {
            departmentId: _this.department.id,
            idGoogleSheet: _this.tagSync.idGoogleSheet,
            sheetName: _this.tagSync.sheetName,
        });
    }

    this.close = () => {
        $state.go("dashboard.departments.department.admin", {
            departmentId: _this.department.id
        });
    }
};
